import React from "react";

const UserHeader = ({ headerImg, mainText, pageName }) => {
  return (
    <header
      className="bg-cover bg-center flex flex-col md:flex-row items-center w-full md:h-72 h-28 py-4 lg:px-20 md:px-10 px-5 md:p-10"
      style={{ backgroundImage: `url(${headerImg})` }}>
      <div className="w-full flex flex-col md:flex-row items-center justify-center">
        <div>
          <h1 className="text-white tracking-wider text-3xl md:text-4xl font-bold text-center">
            {pageName}
          </h1>
        </div>
      </div>
    </header>
  );
};

export default UserHeader;
